import React, { useEffect, useState } from 'react';

import { CurrentProject } from '../RydProjectContainers';

import './EurydiceApp.css';

import { LibraryPanel } from '../panels/LibraryPanel';
import { InspectorPanel } from '../panels/InspectorPanel';
import { RydFeatures } from '../../utils/FeatureToggle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBars,
    faUser
} from '@fortawesome/free-solid-svg-icons';
import { UserAccountPanel } from '../panels/UserAccountPanel';
import { RydUserAccount } from '../../accounts/model';
import {
    CurrentUserAccountState,
    RydSessionState,
    useCurrentUserAccountStore,
    useUserSession
} from '../../stores/CurrentUserAccountStore';
import RydLogin from '../account/RydLogin';
import {
    GlobalDataProvider
} from '../../GlobalDataContext';
import { API } from '../../ApiClient';
import { normalizeClassName } from '../../render/renderUtils';
import { RydProject } from '../../model/project';
import { RydMixerPanel } from '../panels/MixerPanel';
import { ApplicationMainOptionsPanel } from '../panels/ApplicationMainOptionPanel';
import { useZoomStore } from '../../stores/ZoomStore';
import { useMixerStore } from '../../stores/MixerStore';
import { useWorkspaceInputSourceAssignments } from '../../stores/WorkspaceStore';
import { RecordArmController } from '../../audio/RecordingController';


function RydWorkspace() {

    const [project, setProject] = React.useState<RydProject>();

    const [isLibraryCollapsed, setLibraryCollapsed] = useState(true);
    const [isInspectorCollapsed, setInspectorCollapsed] = useState(true);
    const [isAppMenuCollapsed, setAppMenuCollapsed] = useState(true);
    const [isUserAccountCollapsed, setUserAccountVisible] = useState(true);
    const [isMixerCollapsed, setMixerCollapsed] = useState(true);

    const currentUserAccountStore = useCurrentUserAccountStore();
    const sessionStore = useUserSession();
    const mixerStore = useMixerStore();
    const zoomStore = useZoomStore();
    const workspaceInputSourceAssignments = useWorkspaceInputSourceAssignments();

    const [initialized, setInitialized] = useState(false);

    const toggleLibraryCollapse = () => {
        setLibraryCollapsed(!isLibraryCollapsed);
    };

    const toggleInspectorCollapse = () => {
        setInspectorCollapsed(!isInspectorCollapsed);
    };

    const toggleUserAccountVisibility = () => {
        setUserAccountVisible(!isUserAccountCollapsed);
    }

    const toggleAppMenuCollapse = () => {
        setAppMenuCollapsed(!isAppMenuCollapsed);
    };

    const toggleMixerCollapse = () => {
        setMixerCollapsed(!isMixerCollapsed);
    };

    function updateWorkspace(project: RydProject) {
        console.warn('!!!!Updating workspace with project', project);
        setProject(project);
        setInitialized(false);
    }

    // if (!currentUserAccountStore.account) {
    if (!sessionStore.accessToken) {
        console.warn('No user account found');
        // window.location.href = '/login';
        return null;
    }

    const accountServicesClasses = (isUserAccountCollapsed ? [] : ["active"]).concat(["account-services"]);

    return (
        <div id="ryd-session-frame">
            <div id="header">
                <div id="logo">
                    {/* <img src={logo} height={28} /> */}
                    <h1>rydice</h1>
                </div>

                {currentUserAccountStore.account &&
                    <div className={normalizeClassName(accountServicesClasses)}>
                        <span className="ryd-account-balance" onClick={toggleUserAccountVisibility} >
                            {currentUserAccountStore.account.user.username}
                            <FontAwesomeIcon icon={faUser} size={'2x'} />
                        </span>
                        <FontAwesomeIcon icon={faBars} size={'2x'} onClick={toggleAppMenuCollapse} />
                    </div>
                }
            </div>
            <div id="ryd-workspace">
                {project && <>
                    <CurrentProject
                        project={project}
                        initialized={initialized}
                        setInitialized={setInitialized}
                        toggleLibraryCollapse={toggleLibraryCollapse}
                        toggleInspectorCollapse={toggleInspectorCollapse}
                        toggleMixerCollapse={toggleMixerCollapse}
                    />
                    <LibraryPanel
                        isCollapsed={isLibraryCollapsed}
                        toggleCollapse={toggleLibraryCollapse}
                        // setProject={updateWorkspace}
                        project={project}
                    />
                </>}
                <UserAccountPanel
                    isCollpsed={isUserAccountCollapsed}
                    toggleCollapse={toggleUserAccountVisibility} />

                {RydFeatures.Toggle.isOn('INSPECTOR_PANEL') &&
                    <InspectorPanel
                        isCollapsed={isInspectorCollapsed}
                        toggleCollapse={toggleInspectorCollapse}
                    />
                }

                <ApplicationMainOptionsPanel
                    isCollapsed={isAppMenuCollapsed}
                    toggleCollapsed={() => setAppMenuCollapsed(!isAppMenuCollapsed)}
                    setProject={(project: RydProject) => {
                        console.log('THIS IS THE REAL PROJECT INIT/LOAD', project);
                        zoomStore.setZoomFactor(project.uiState?.zoomFactor || project.getAll()[0].getPPQ());
                        workspaceInputSourceAssignments.clear();
                        RecordArmController.getInstance().clearArmedTracks();
                        RecordArmController.getInstance().clearMonitoringTracks();

                        updateWorkspace(project);
                    }}
                />

                {project &&
                    <RydMixerPanel
                        onUpdate={(id, changes) => {
                            if (!project) return;
                            const orig = project.mixerState.tracks.get(id)!;
                            const referenceState = { ...orig, ...changes }

                            project.mixerState.tracks.set(id, referenceState);
                            mixerStore.mixer?.updateTrack(id, referenceState);
                            mixerStore.forceUpdate();
                        }}
                        onUpdateMaster={(changes) => {
                            if (!project) return;
                            const orig = project.mixerState.master;
                            const referenceState = { ...orig, ...changes }

                            project.mixerState.master = referenceState;
                            mixerStore.mixer?.setMasterGain(referenceState.gain);
                            mixerStore.forceUpdate();
                        }}
                        isCollapsed={isMixerCollapsed}
                        toggleCollapse={toggleMixerCollapse}
                    />
                }
            </div>
        </div>
    );
}

const wrap = (el) => {
    return (
        <React.StrictMode>
            <GlobalDataProvider>
                {el}
            </GlobalDataProvider>
        </React.StrictMode>
    );
}

function onLogin(
    email: string,
    password: string,
    sessionStore: RydSessionState,
    currentUserAccountStore: CurrentUserAccountState
) {

   API.authenticateUser(email, password).then((r) => {
        currentUserAccountStore.setAccount({
            user: {
                id: 1,
                customerNumber: r['customer_number'],
                name: r['name'],
                email: email,
                username: r['username'],
            },
            balance: 100.0,
            status: 'active',
            createdAt: new Date(),
        } as RydUserAccount);

        sessionStore.setUser({
            user: {
                id: 1,
                customerNumber: r['customer_number'],
                name: r['name'],
                email: email,
                username: r['username'],
            },
            balance: 100.0,
            status: 'active',
            createdAt: new Date(),
        } as RydUserAccount);
        sessionStore.setTokens(r['access_token'], r['refresh_token']);
    }).catch((error) => {
        console.error('Login failed:', error);
    });
}

function checkAccessTokenValid(
    sessionStore: RydSessionState,
    setIsTokenValid: (isValid: boolean) => void,
    currentUserAccountStore: CurrentUserAccountState
) {
    const cn = sessionStore.user?.user?.customerNumber;
    if (!sessionStore.user?.user?.customerNumber || !sessionStore.accessToken) {
        setIsTokenValid(false);
        return;
    }

    API.getUserAccount(sessionStore.accessToken)
        .then((d) => {
            setIsTokenValid(true);

            currentUserAccountStore.setAccount({
                user: {
                    // id: d.user.id,
                    customerNumber: d['customer_number'],
                    name: d['first_name'],
                    email: d['email'],
                    username: d['username'],
                },
                balance: d.balance,
                status: d.status,
                createdAt: new Date(d.createdAt),
            } as RydUserAccount);
        })

        .catch((error) => {
            console.error('Token validation failed:', error);
            setIsTokenValid(false);
        });
}

export function EurydiceRoot() {
    const currentUserAccountStore: CurrentUserAccountState = useCurrentUserAccountStore();
    const sessionStore: RydSessionState = useUserSession();
    const [isTokenValid, setIsTokenValid] = React.useState<boolean | null>(null);

    React.useEffect(() => checkAccessTokenValid(sessionStore, setIsTokenValid, currentUserAccountStore), [sessionStore.accessToken]);

    // if (currentUserAccountStore.account === null) {

    if (RydFeatures.Toggle.isOn('LOGIN_REQUIRED')) {

        if (isTokenValid === null) {
            return wrap(<div>Validating token...</div>);
        }

        if (!sessionStore.accessToken || !isTokenValid) {
            console.log('No user account found, showing login');
            return wrap(<RydLogin onLogin={(e, p) => onLogin(e, p, sessionStore, currentUserAccountStore)} />);
        }
    }
    return wrap(<RydWorkspace />);
}
